import DOM from '@common/DOM/DOM'

import styles from './errorElem.css'

/** Egy hiba element legyártása. */
export default function makeErrorElem (): HTMLElement {
  const elem = document.createElement('div')
  elem.classList.add(styles.error)

  DOM.once(elem, 'click', () => {
    DOM.remove(elem)
  })

  return elem
}
